const fillArray = (size: number, itemCallback: (number) => any) =>
  new Array(size).fill("").map((item, index) => itemCallback(index));

export default fillArray;
